import { CAST_AI } from '@cast/constants';
import {
  Button,
  DialogTitle,
  DialogActions,
  DialogContent,
  Icons,
  Spinner,
  ExternalLink,
  Typography,
  Box,
  Stack,
} from '@cast/design-system';

import { ClusterDialogHeaderActions } from 'hooks/dialogs/cluster/_components/ClusterDialogHeaderActions';
import { ClusterDialogTitle } from 'hooks/dialogs/cluster/_components/new-onboarding';

const DIALOG_CONTENT_PADDING = 24;
const CONTENT_LEFT_PADDING = 46;

type Props = {
  onClose: () => void;
  onBack: () => void;
};

export const WhatHappensNextStepDialogContent = ({
  onClose,
  onBack,
}: Props) => {
  return (
    <Box data-testid="what-happens-next-step-dialog-content">
      <DialogTitle>
        <Stack
          direction="row"
          gap={4}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" gap={12} alignItems="center">
            <Spinner size={32} color="secondary" />
            <ClusterDialogTitle>Enabling {CAST_AI} features</ClusterDialogTitle>
          </Stack>

          <ClusterDialogHeaderActions onClose={onClose} />
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ pb: 0 }}>
        <Stack gap={16}>
          <Stack gap={12}>
            <Stack gap={2} pl={CONTENT_LEFT_PADDING}>
              <Typography variant="P14M">What happens next?</Typography>

              <Box sx={{ my: 0, pl: 8 }}>
                <Typography variant="P12R" color="textSecondary">
                  • {CAST_AI} components will be deployed to your cluster
                </Typography>
                <Typography variant="P12R" color="textSecondary">
                  • Data collection will begin within 5 minutes
                </Typography>
                <Typography variant="P12R" color="textSecondary">
                  • Features will be enabled and can be configured via the
                  Settings page.
                </Typography>
              </Box>
            </Stack>
          </Stack>
          <Stack
            pl={DIALOG_CONTENT_PADDING + CONTENT_LEFT_PADDING}
            py={8}
            mx={-DIALOG_CONTENT_PADDING}
            gap={4}
            bgcolor="blue.50"
            borderTop="blue.100"
            borderBottom="blue.100"
          >
            <Typography variant="P12R" color="textSecondary">
              You can monitor installed components in{' '}
              <ExternalLink link="/organization/management/component-control/components">
                Component control page
              </ExternalLink>
            </Typography>
            <Typography variant="P12R" color="textSecondary">
              Closing this dialog will not affect the process.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button
          variant="ghost"
          startIcon={<Icons.ArrowLeft />}
          onClick={onBack}
        >
          Back
        </Button>
        <Button
          data-testid="what-happens-next-step-dialog-close-button"
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Box>
  );
};
